/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { createTheme, type MantineColorsTuple } from '@mantine/core';
import appConfig from '../../../ui-config.json';

type PaletteKey = keyof typeof appConfig.colors;

const colors = Object.fromEntries(
  Object.entries(appConfig.colors).map(([key, shades]) => [
    key,
    shades as unknown as MantineColorsTuple,
  ]),
) as Record<PaletteKey, MantineColorsTuple>;

export const theme = createTheme({
  primaryColor: appConfig.primaryColor,
  colors,
  fontFamily: appConfig.fontFamily,
  defaultRadius: 'md',
  radius: {
    sm: appConfig.radius.sm,
    md: appConfig.radius.md,
    lg: appConfig.radius.lg,
  },
  other: {
    light: appConfig.light,
    dark: appConfig.dark,
    pillRadius: appConfig.radius.pill,
    brandName: appConfig.brand.name,
    productName: appConfig.brand.productName,
    phaseColors: appConfig.phaseColors,
    chartSeriesColors: appConfig.chartSeriesColors,
  },
});

export const defaultColorScheme = appConfig.colorScheme as 'light' | 'dark';
